import React from "react";
import { useFieldArray } from "react-hook-form";
import { Button } from "semantic-ui-react";
import { GetProducts } from "../../../Api/api";
import { useQuery } from "react-query";

export default function Fields({ control, register }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "products",
  });

  const { data } = useQuery("Get_Products", () => {
    return GetProducts();
  });

  const listeDeProd = data?.data?.map((oneProd, i) => (
    <option key={i} className="prodItem" value={oneProd.id_acte}>
      {oneProd.nom_acte} - {oneProd.prix_acte} DH
    </option>
  ));

  return (
    <>
      {fields.map((item, index) => {
        return (
          <div
            className="equal width fields"
            key={item.id}
            style={{ margin: "0 -.0em 1em" }}
          >
            <div
              className="required field"
              style={{ paddingLeft: "0", width: "60%" }}
            >
              <select
                style={{ width: "60%" }}
                // role="listbox"
                aria-expanded="false"
                className="ui selection dropdown prodItem"
                required
                {...register(`products.${index}.fk_id_acte`)}
              >
                <option className="prodItem" value="0">
                  CHOISISSEZ UNE OPTION
                </option>
                {listeDeProd}
              </select>
            </div>

            <Button floated="right" color="red" onClick={() => remove(index)}>
              supprimer ce formulaire
            </Button>
          </div>
        );
      })}

      <section>
        <Button
          type="button"
          floated="right"
          color="yellow"
          onClick={() => {
            append({ fk_id_acte: "1" });
          }}
        >
          Ajouter une prestation
        </Button>
      </section>
    </>
  );
}
